<div class="w-full flex flex-col gap-y-2">
    <div class="flex flex-row items-center gap-x-4 w-full pt-2">
        <h2 class="text-sm font-semibold text-primary flex-nowrap min-w-fit">Ad Details</h2>
        <div class="border-b border-gray-200 dark:border-gray-800 w-full"></div>
        <button (click)="expanded.set(!expanded())" type="button" class="fab-button-secondary-small text-secondary">
            @if (expanded()) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m18 15-6-6-6 6" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m6 9 6 6 6-6" />
            </svg>
            }
        </button>
    </div>


    @if (expanded()) {
    <article class="briefing-section-card relative isolate flex flex-col gap-8 lg:flex-row">
        <div class="flex flex-row gap-x-6 gap-y-8">

            <article class="flex-1 flex flex-col gap-y-4">

                <div class="w-full">
                    <label for="ad-group-name-input" class="block text-sm/6 font-medium text-primary">
                        Ad Details
                        <p class="text-xs text-secondary">Set creatives, CTAs and Disclaimers for your Spark Ad.</p>
                    </label>
                </div>

                <!-- Ad Creative - None Selected -->
                @if (!createSparkCampaignService.selectedCreative()) {
                <div
                    class="w-full flex flex-row justify-between items-center border-b border-gray-200 dark:border-gray-800 pb-4">
                    <label for="ad-group-name-input" class="flex-1 block text-sm/6 font-medium text-primary">
                        Ad Creative
                        <p class="text-xs text-secondary">Select the content item you want to promote.</p>
                    </label>

                    <cad-select-creative></cad-select-creative>
                </div>
                }
                <!-- Ad Creative - None Selected - END -->

                <!-- Ad Creative - Selected -->
                @if (createSparkCampaignService.selectedCreative()) {
                <div class="w-full flex flex-col gap-y-4 border-b border-gray-200 dark:border-gray-800 pb-4">
                    <label for="ad-group-name-input" class="flex-1 block text-sm/6 font-medium text-primary">
                        Ad Creative
                        <p class="text-xs text-secondary">Select the content item you want to promote.</p>
                    </label>
                    <div class="flex mt-2">
                        <div class="mr-4 shrink-0">
                            <div class="h-32 w-auto aspect-9/16 overflow-hidden">
                                <img class="h-32 w-auto object-cover"
                                    [src]="createSparkCampaignService.selectedCreative()!.video_info.thumbnail_url"
                                    alt="">
                            </div>
                        </div>
                        <div>
                            <label for="ad-group-name-input" class="block text-sm/6 font-medium text-primary">
                                {{ createSparkCampaignService.selectedCreative()!.creator_info.display_name }}
                            </label>
                            <div class="flex flex-row gap-x-2">
                                <span
                                    class="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600 dark:bg-gray-400/10 dark:text-gray-400">{{
                                    createSparkCampaignService.selectedCreative()!.video_info.video_id }}</span>
                                <span
                                    class="inline-flex items-center rounded-md bg-gray-100 px-2 py-1 text-xs font-medium text-gray-600 dark:bg-gray-400/10 dark:text-gray-400">{{
                                    getVideoDuration(createSparkCampaignService.selectedCreative()!.video_view_retention.length)
                                    }}</span>
                            </div>

                            <div class="flex flex-row gap-x-2 mt-2">
                                <cad-select-creative [smallMode]="true"></cad-select-creative>
                            </div>
                        </div>
                    </div>

                    <!-- Ad Text -->
                    <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                        <div class="sm:col-span-full">
                            <label for="ad-group-name-input" class="block text-sm/6 font-medium text-primary">
                                Ad Text
                                <p class="text-xs text-secondary">Shown to your audience as part of your ad creative, to
                                    deliver the message you intend to communicate to them.</p>
                            </label>
                            <div
                                class="mt-2 flex rounded-md bg-white outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-primary dark:bg-white/5 dark:outline-1 dark:-outline-offset-1 dark:outline-white/10 dark:focus-within:outline-primary overflow-hidden">
                                <input id="search" type="text" name="search"
                                    class="block min-w-0 grow px-3 py-1.5 bg-input text-foreground placeholder:text-gray-400 focus:outline-none sm:text-sm/6 rounded-l-radius"
                                    placeholder="Your ad text here..." maxlength="100"
                                    [value]="createSparkCampaignService.ad_text() ?? ''"
                                    (input)="onAdTextInput($event)" />
                                <div class="flex px-2 bg-input text-foreground rounded-r-radius items-center justify-center">
                                    <p class="text-xs text-secondary">{{ createSparkCampaignService.ad_text()?.length ?? 0 }}/100</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Ad Text -->
                </div>
                }
                <!-- Ad Creative - Selected - END -->



                <!-- Ad CTA -->
                <section class="w-full flex flex-col gap-y-2 border-b border-gray-200 dark:border-gray-800 pb-4">
                    <div class="flex items-center justify-between gap-x-4">
                        <span class="flex grow flex-col">
                            <label id="availability-label"
                                class="text-sm/6 font-medium text-gray-900 dark:text-white">Call
                                To Action</label>
                            <span id="availability-description" class="text-sm text-gray-500 dark:text-gray-400">Choose
                                the
                                action you want people to take when they see your ad. It appears as part of your ad
                                creative, and its display position will be dynamically adjusted based on delivery
                                performance.</span>
                        </span>
                        <div
                            class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-primary transition-colors duration-200 ease-in-out has-checked:bg-primary has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-primary dark:has-checked:bg-primary">
                            <span
                                class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"></span>
                            <input id="availability" type="checkbox" name="availability"
                                aria-labelledby="availability-label" aria-describedby="availability-description"
                                [checked]="isCallToActionActive()" (input)="onCallToActionActiveInput($event)"
                                class="absolute inset-0 size-full appearance-none focus:outline-hidden" />
                        </div>
                    </div>

                    @if (isCallToActionActive()) {
                    <fieldset aria-label="Plan">
                        <div class="space-y-2">
                            <div class="relative flex items-start">
                                <div class="flex h-6 items-center">
                                    <input id="small" type="radio" name="plan" checked
                                        aria-describedby="small-description"
                                        class="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-primary checked:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 dark:border-white/10 dark:bg-white/5 dark:checked:border-primary dark:checked:bg-primary dark:focus-visible:outline-primary dark:disabled:border-white/5 dark:disabled:bg-white/10 dark:disabled:before:bg-white/20 forced-colors:appearance-auto forced-colors:before:hidden" />
                                </div>
                                <div class="ml-3 text-sm/6">
                                    <label for="small" class="font-medium text-gray-900 dark:text-white">Dynamic</label>
                                    <p id="small-description" class="text-gray-500 dark:text-gray-400">Automatically
                                        show different call to action text to different users to maximize performance.
                                    </p>
                                </div>
                            </div>
                            <div class="relative flex items-start">
                                <div class="flex h-6 items-center">
                                    <input id="medium" type="radio" name="plan" aria-describedby="medium-description"
                                        class="relative size-4 appearance-none rounded-full border border-gray-300 bg-white before:absolute before:inset-1 before:rounded-full before:bg-white not-checked:before:hidden checked:border-primary checked:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary disabled:border-gray-300 disabled:bg-gray-100 disabled:before:bg-gray-400 dark:border-white/10 dark:bg-white/5 dark:checked:border-primary dark:checked:bg-primary dark:focus-visible:outline-primary dark:disabled:border-white/5 dark:disabled:bg-white/10 dark:disabled:before:bg-white/20 forced-colors:appearance-auto forced-colors:before:hidden" />
                                </div>
                                <div class="ml-3 text-sm/6">
                                    <label for="medium"
                                        class="font-medium text-gray-900 dark:text-white">Standard</label>
                                    <p id="medium-description" class="text-gray-500 dark:text-gray-400">Select a static
                                        call to action text.</p>
                                </div>
                            </div>
                        </div>
                    </fieldset>
                    }
                </section>
                <!-- Ad CTA - END -->

                <!-- Destination -->
                <section class="w-full flex flex-col gap-y-2">
                    <div
                        class="w-full flex flex-row items-start gap-x-4 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 p-2">
                        <div class="shrink-0">
                            <button (click)="destinationExpanded.set(!destinationExpanded())" type="button"
                                class="fab-button-secondary-small text-secondary">
                                @if (destinationExpanded()) {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path d="m6 9 6 6 6-6" />
                                </svg>
                                } @else {
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="size-5">
                                    <path d="m9 18 6-6-6-6" />
                                </svg>
                                }
                            </button>
                        </div>

                        @if (createSparkCampaignService.call_to_action_active()) {
                        @if (!destinationExpanded()) {
                        <div (click)="destinationExpanded.set(!destinationExpanded())"
                            class="flex-1 flex flex-col gap-y-2 hover:cursor-pointer">
                            <label for="ad-group-name-input" class="block text-md font-medium text-primary">
                                Destination
                            </label>
                            <ul role="list" class="flex flex-col gap-y-0 text-gray-600 dark:text-gray-400">
                                <li class="inline-flex gap-x-3">
                                    <p class="text-sm text-primary font-semibold">Destination URL: </p>
                                    <p class="text-sm text-secondary"
                                        [attr.title]="createSparkCampaignService.landing_page_url() ?? ''">
                                        {{ truncatedLandingPageUrl() }}
                                    </p>
                                </li>
                                <!-- Deeplink only available  -->
                                <li class="inline-flex gap-x-3">
                                    <p class="text-sm text-primary font-semibold">Deeplink First: </p>
                                    <p class="text-sm text-secondary">Yes or no</p>
                                </li>
                                <li class="inline-flex gap-x-3">
                                    <p class="text-sm text-primary font-semibold">Disclaimer: </p>
                                    <p class="text-sm text-secondary">Is there a disclaimer for the destination URL?</p>
                                </li>
                            </ul>
                        </div>
                        } @else {
                        <div class="flex-1 flex flex-col gap-y-2">

                            <label for="ad-group-name-input" class="block text-md font-medium text-primary">
                                Destination
                            </label>

                            <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                <div class="sm:col-span-full">
                                    <label for="ad-group-name-input" class="block text-sm/6 font-medium text-primary">
                                        Destination URL
                                        <p class="text-xs text-secondary">Provide the landing page or website you want
                                            to promote. Adding links that match the data connection you selected in the
                                            ad group can help you track performance.</p>
                                    </label>
                                    <div class="mt-2 relative flex items-center w-full shadow-xs rounded-md">
                                        <input type="url" id="ad-group-name-input" inputmode="url"
                                            class="border-x-0 input-primary text-left text-primary h-10 w-full px-3"
                                            placeholder="https://example.com/landing-page"
                                            [value]="createSparkCampaignService.landing_page_url() ?? ''"
                                            (input)="onLandingPageUrlInput($event)" />
                                    </div>
                                </div>

                                <!-- Direct users to Deeplink first? -->
                            </div>
                        </div>
                        }
                        } @else {
                        <div class="flex-1 flex flex-col gap-y-2 hover:cursor-pointer">
                            <label for="ad-group-name-input" class="block text-md font-medium text-primary">
                                Destination
                            </label>
                            <ul role="list" class="flex flex-col gap-y-0 text-gray-600 dark:text-gray-400">
                                <li class="inline-flex gap-x-3">
                                    <p class="text-sm text-primary font-semibold">Enable CTA to apply a Destination.</p>
                                </li>
                            </ul>
                        </div>
                        }




                    </div>
                </section>
                <!-- Destination - END -->

                <!-- Disclaimer -->
                <div class="flex items-center justify-between col-span-full"
                    [class]="isDisclaimerEnabled() ? '' : 'border-b border-gray-200 dark:border-gray-800 pb-4'">
                    <span class="flex grow flex-col">
                        <label id="availability-label"
                            class="text-sm/6 font-medium text-gray-900 dark:text-white">Disclaimer</label>
                        <span id="availability-description" class="text-sm text-gray-500 dark:text-gray-400">Adding
                            disclaimers to your
                            ads could help you avoid legal risks.</span>
                    </span>
                    <div
                        class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-primary transition-colors duration-200 ease-in-out has-checked:bg-primary has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-primary dark:has-checked:bg-primary">
                        <span
                            class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"></span>
                        <input id="availability" type="checkbox" name="availability"
                            aria-labelledby="availability-label" aria-describedby="availability-description"
                            [checked]="isDisclaimerEnabled()" (input)="onEnableDisclaimerInput($event)"
                            class="absolute inset-0 size-full appearance-none focus:outline-hidden" />
                    </div>
                </div>

                @if (isDisclaimerEnabled()) {

                <div class="sm:col-span-full"
                    [class]="isDisclaimerEnabled() ? 'border-b border-gray-200 dark:border-gray-800 pb-4' : ''">
                    <label for="ad-group-name-input" class="block text-sm/6 font-medium text-primary">
                        Disclaimer Text
                        <p class="text-xs text-secondary">This text will be displayed at the bottom of
                            your ad creative.</p>

                    </label>
                    <div class="mt-2 relative flex flex-col items-start w-full shadow-xs rounded-md">
                        <textarea id="ad-group-name-input" rows="3" maxlength="90"
                            class="border-x-0 input-primary text-left text-primary w-full px-3 py-2 resize-none"
                            placeholder="e.g. Results may vary. Terms apply."
                            [value]="createSparkCampaignService.disclaimer_text() ?? ''"
                            (input)="onDisclaimerTextInput($event)"></textarea>
                    </div>
                    <p class="text-xs text-secondary font-normal">Must be between 1 and 90
                        characters.</p>
                </div>
                }
                <!-- Disclaimer - END -->


            </article>
            <article class="shrink-0 h-full flex flex-col items-end justify-end">
                <cad-ad-preview class="w-80"></cad-ad-preview>
            </article>


        </div>

    </article>
    }
</div>